<p class="p2 col2" [ngClass]="message && 'p-t-2 p-b-2'">{{message}}</p>
